/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { FormsModule } from '@angular/forms';
import { VirtualListDropdownComponent } from './virtual-list-dropdown.component';
import { VirtualListModule } from '../virtual-list/virtual-list.module';
import { DirectivesModule } from '../../directives/directives.module';
import { DropdownModule } from '../dropdown/dropdown.module';

@NgModule({
  declarations: [VirtualListDropdownComponent],
  exports: [VirtualListDropdownComponent],
  entryComponents: [VirtualListDropdownComponent],
  imports: [
    CommonModule,
    AngularSvgIconModule,
    TranslateModule,
    TooltipModule,
    FormsModule,
    DirectivesModule,
    DropdownModule,
    VirtualListModule
  ]
})
export class VirtualListDropdownModule {}

export { VirtualListDropdownComponent };
